<template>
    <div class="vrm-modal vrm-modal--unsave-notification mfp-with-anim">
        <div class="vrm-modal__container">
            <div class="vrm-modal__header">
                <svg
                    class="vrm-modal__title-icon"
                    width="33"
                    height="28"
                    viewBox="0 0 33 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M32.2501 26.1875L25.9376 15.2812C25.6667 14.7812 25.323 14.1771 24.9063 13.4688C24.4897 12.7396 24.1355 12.125 23.8438 11.625L17.5626 0.75C17.4167 0.5 17.2501 0.3125 17.0626 0.1875C16.8751 0.0625 16.6876 0 16.5001 0C16.3126 0 16.1251 0.0625 15.9376 0.1875C15.7501 0.3125 15.5834 0.5 15.4376 0.75L9.15633 11.625C8.86466 12.125 8.5105 12.7396 8.09383 13.4688C7.67717 14.1771 7.33342 14.7812 7.06258 15.2812L0.750081 26.1875C0.458415 26.6875 0.416748 27.1146 0.625081 27.4688C0.833415 27.8229 1.22925 28 1.81258 28H14.4063C14.9897 28 15.6876 28 16.5001 28C17.3126 28 18.0105 28 18.5938 28H31.1876C31.7709 28 32.1667 27.8229 32.3751 27.4688C32.5834 27.1146 32.5417 26.6875 32.2501 26.1875ZM3.50008 26H3.18758L16.5001 2.9375L29.8751 26H3.50008ZM15.5001 22H17.5001V24H15.5001V22ZM15.5001 10H17.5001V20H15.5001V10Z"
                    />
                </svg>
                <div class="vrm-modal__title">
                    {{
                        this.$t('modal.unsaved-changes.title', {
                            i18nFallback: 'You have unsaved changes',
                        })
                    }}
                </div>
            </div>
            <div class="vrm-modal__content">
                {{
                    this.$t('modal.unsaved-changes.notification', {
                        i18nFallback:
                            'Your changes will be lost if you leave this page without submitting',
                    })
                }}
            </div>
            <div class="sg-spread">
                <button type="reset" class="sg-btn sg-site" @click="closeModal">
                    {{
                        this.$t('modal.unsaved-changes.leave', {
                            i18nFallback: 'Leave Page',
                        })
                    }}
                </button>
                <button type="submit" class="sg-btn sg-blue" @click="onConfirm">
                    {{
                        this.$t('modal.unsaved-changes.submit', {
                            i18nFallback: 'Submit Change',
                        })
                    }}
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped></style>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalCloseHandle from '@/vue/components/modals/ModalCloseHandle.vue';
import { ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: {
        ModalCloseHandle,
    },
})
@AngularLocaleBundle('modal')
export default class ChangeUnsaveNotificationModal extends Vue {
    @Prop()
    callbackSave;
    @Prop()
    callbackReset;
    @ngInject()
    AppearanceService;

    onConfirm() {
        this.callbackSave();
        $.magnificPopup.close();
    }
    closeModal() {
        this.callbackReset();
        $.magnificPopup.close();
    }
}
</script>
